import React, { useEffect, useRef, useState } from "react";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { usePushStore } from "@shared/libs/pushStore";
import FcmAlarmMessageBox from "./FcmAlarmMessageBox";
import { messageCenterMenuArgs } from "./fcmAlarmMenu";

type Props = {
  /** MainLayout의 handleMenuClick (Header 경유) */
  onMenuClick?: (
    menuKey: string,
    menuTitle: string,
    cd_module: string,
    filePath: string,
    data: any,
    menuPath: string
  ) => void;
};

/**
 * 헤더 알림종.
 * - 미확인 알림이 있으면 종 오른쪽 위에 빨간 점
 * - 클릭 시 FcmAlarmMessageBox 팝업이 아래로 펼쳐지고, 바깥 클릭/X로 닫힘
 */
export default function FcmNotificationBell({ onMenuClick }: Props) {
  const unreadCount = usePushStore((state) => state.unreadCount);
  const refresh = usePushStore((state) => state.refresh);
  const hasUnread = unreadCount > 0;

  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  // 로그인/새로고침 직후 서버 기준 미확인 수로 빨간 점 초기화 (이후는 FCM 수신마다 refresh)
  useEffect(() => {
    void refresh();
  }, [refresh]);

  useEffect(() => {
    if (!isOpen) return;
    function handleClickOutside(e: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="relative flex items-center" ref={wrapperRef}>
      <button
        className="relative flex items-center text-gray-600"
        type="button"
        aria-label={hasUnread ? `알림 ${unreadCount}건 미확인` : "알림"}
        title={hasUnread ? `미확인 알림 ${unreadCount}건` : "알림"}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <NotificationsNoneRoundedIcon sx={{ fontSize: "1.6rem" }} />
        {hasUnread && (
          <span className="absolute top-0.5 right-0.5 h-1.5 w-1.5 rounded-full bg-red-500" />
        )}
      </button>

      {isOpen && (
        <FcmAlarmMessageBox
          onClose={() => setIsOpen(false)}
          onOpenMessageCenter={() => onMenuClick?.(...messageCenterMenuArgs())}
        />
      )}
    </div>
  );
}
